<nb-card class="modal-full">
  <nb-card-header>
    <div class="start inline-flex">
      <div class="">Edit resource</div>
    </div>
    <div class="end ml-4">
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <label for="labels">Label</label>
      <multilang-editor [model]="_model.labels" editMode="true" [htmlMode]="false" [simple]="true" [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
    </div>
    <div class="form-group">
      <label for="labels">Description</label>
      <multilang-editor [model]="_model.description" editMode="true" [htmlMode]="true" [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
    </div>
    <div class="card-block">
      <label>Resource picture</label>
      <div class="row">
        <div class="col-3 form-group" style="text-align:center;" *ngIf="!_model.id">
          Please save new resource first
        </div>
        <div class="col-3" *ngIf="_model.id">
          <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
            [progress]="progressMap['OBJECT']" (fileUpdated)="handleFileUpdated($event, null)"
            [imageUrl]="_model?.pictureUrl"></image-uploader>
        </div>
        <div class="col-3 justify-content-end pr-5" *ngIf="_model.pictureUrl">
          <button nbButton ghost status="danger" (click)="deletePicture(null)">
            <nb-icon icon="trash"></nb-icon>
          </button>
        </div>
      </div>

      <!--<label>Language specific picture</label>
      <div class="row">
        <div class="col-3 form-group" style="text-align:center;" *ngIf="!_model.id">
          Please save new resource first
        </div>
        <ng-template ngFor let-lang="$implicit" [ngForOf]="languages">
          <div class="col-3" *ngIf="_model.id">
            {{ lang }}
            <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
              [progress]="progressMap['OBJECT'+lang]"
              (fileUpdated)="handleFileUpdated($event, lang)"
              [imageUrl]="_model.objectPic[lang] ? _model.objectPic[lang].url : null">
            </image-uploader>
            <div class="row justify-content-end pr-5">
              <button nbButton ghost status="danger" (click)="deletePicture(lang)"
                *ngIf="_model.objectPic[lang] && _model.objectPic[lang].url">
                <nb-icon icon="trash"></nb-icon>
              </button>
            </div>
          </div>
        </ng-template>
      </div>-->
    </div>
    <div class="form-group">
      <label for="externalUrl">Embedded external URL</label>
      <input class="form-control" placeholder="Enter full url here" [(ngModel)]="_model.externalUrl">
    </div>
    <div class="form-group">
      <label class="control-label">Language specific url</label>
      <multilang-editor [model]="_model?.externalUrlByLanguage" editMode="true" [htmlMode]="false" [simple]="true"
        [languages]="languages">
      </multilang-editor>
    </div>
    <div class="form-group">
      <nb-toggle status="info" [(ngModel)]="_model.isExternalUrlInNewWindow"
      [ngModelOptions]="{standalone: true}">Opens in external browser</nb-toggle>
    </div>
    <div class="form-group" *ngIf="_model.isExternalUrlInNewWindow">
      <label class="control-label">Button label</label>
      <multilang-editor [model]="_model?.externalUrlLabel" editMode="true" [htmlMode]="false" [simple]="true"
        [languages]="languages" [defaultLang]="game?.defaultLang">
      </multilang-editor>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="row">
      <button class="cancel" nbButton status="danger" (click)="cancel()">Cancel</button>
      <button class="save" nbButton status="success" (click)="save()">Save</button>
    </div>
  </nb-card-footer>
</nb-card>
